import { constants } from '@nhl/formatter-utilities';

import playersAPI from 'media-base-ui/utils/playersAPI';

import actionCreators from './actionCreators';

const flushCache = actionCreators.flushCache;

const fetchPlayersByBirthday = (month, day, season) => async dispatch => {
    dispatch(actionCreators.requestPlayers());

    try {
        const data = await playersAPI.fetchPlayersByBirthday({
            month,
            day,
            season // takes a season to limit the number of logos fetched. Reducing the network req size by 50%.
        });
        dispatch(actionCreators.playersResponse(true, data.data, constants.BIRTHDAY_FAKE_TEAM, []))
    } catch (error) {
        dispatch(actionCreators.playersResponse(false, [], null, error))
    }
};

const fetchPlayersByTeamId = teamId => async dispatch => {
    dispatch(actionCreators.requestPlayers());

    try {
        const data = await playersAPI.fetchPlayersByTeamId({
            teamId
        });
        dispatch(actionCreators.playersResponse(true, data.data, teamId, []))
    } catch (error) {
        dispatch(actionCreators.playersResponse(false, [], null, error))
    }
};

const fetchPlayersByTeamIdWithHeadshots = (teamId, seasonId) => async dispatch => {
    dispatch(actionCreators.requestPlayers());

    try {
        const data = await playersAPI.fetchPlayersByTeamIdWithHeadshots({
            teamId,
            seasonId
        });
        dispatch(actionCreators.playersResponse(true, data.data, teamId, []))
    } catch (error) {
        dispatch(actionCreators.playersResponse(false, [], null, error))
    }
};

export default {
    fetchPlayersByBirthday,
    fetchPlayersByTeamId,
    fetchPlayersByTeamIdWithHeadshots,
    flushCache
};